/**
 * Competitor name → logo path map.
 *
 * Used by:
 *   - TenderApplicationModal (chip showing the rival bidders on an AO)
 *   - Anywhere else where a competitor name appears as a text chip and
 *     we'd like to surface a small visual identifier
 *
 * Logos generated 04/06/2026 via Nano Banana (Gemini 3.1 Flash Image
 * Preview). Real-world brands (DB Schenker, Géodis, STEF Transport,
 * PharmaUrgence Île-de-France) are deliberately excluded to avoid any
 * trademark issue — they render as text chips only.
 */

const COMPETITOR_LOGOS = {
  // Generated 04/06/2026 (first batch)
  'TransNord Express':        '/competitor-logos/transnord.webp',
  'LogiStar International':   '/competitor-logos/logistar.webp',
  'ÉcoRoute Services':        '/competitor-logos/ecoroute.webp',
  "Rapid'Fret Solutions":     '/competitor-logos/rapidfret.webp',
  // Generated 04/06/2026 (second batch — tender mentions only)
  'MedExpress France':        '/competitor-logos/medexpress-france.webp',
  'EuroSpot Logistics':       '/competitor-logos/eurospot-logistics.webp',
  'Frigo Régional Sud':       '/competitor-logos/frigo-r-gional-sud.webp',
  'Transports Bardin':        '/competitor-logos/transports-bardin.webp',
  'AgriLog Sud':              '/competitor-logos/agrilog-sud.webp',
  'Aéro Express':             '/competitor-logos/a-ro-express.webp',
  'Œnotrans Premium':         '/competitor-logos/notrans-premium.webp',
  // Real-world brands intentionally omitted (trademark caution):
  //   - DB Schenker
  //   - Géodis
  //   - STEF Transport
  //   - PharmaUrgence Île-de-France
};

/**
 * @param {string} name competitor display name (possibly with apostrophes/diacritics)
 * @returns {string|null} logo URL or null if the competitor has no IA logo
 */
export function getCompetitorLogo(name) {
  if (!name) return null;
  if (COMPETITOR_LOGOS[name]) return COMPETITOR_LOGOS[name];
  // Tolerate small variants (curly apostrophe → straight, etc.).
  const normalised = name
    .replace(/\u2019/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
  return COMPETITOR_LOGOS[normalised] || null;
}

export default COMPETITOR_LOGOS;
